import { render } from "./EnquiryDetails.vue?vue&type=template&id=6f1d2b1a"
import script from "./EnquiryDetails.vue?vue&type=script&lang=js"
export * from "./EnquiryDetails.vue?vue&type=script&lang=js"

import "./EnquiryDetails.vue?vue&type=style&index=0&id=6f1d2b1a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__